<template>
  <div id="settings-engineers-threshold">
    <form
      id="settings-engineers-threshold-form"
      data-abide
      novalidate
      @submit.prevent
    >
      <div class="threshold-controls clearfix">
        <div class="float-left threshold-controls-header">
          {{ $t('settings.threshold.header') }}
        </div>
        <div
          v-if="aclHelper.getSettingsUpdateAccess()"
          class="float-right"
        >
          <button
            v-if="!editView"
            type="button"
            class="btn btn--orange"
            @click="editView = true"
          >{{ $t('action.edit') }}</button>
          <button
            v-if="editView"
            v-hkldreset
            type="button"
            class="btn btn--darkblue"
            @click="discardChange()"
          >{{ $t('action.cancel') }}</button>
          <button
            v-if="editView"
            v-hkldreset
            type="button"
            class="btn btn--orange"
            :disabled="disabled"
            @click="save()"
          >{{ $t('action.save') }}</button>
        </div>
        <hr>
      </div>
      <div class="threshold-value clearfix">
        <span>{{ $t('settings.threshold.maxDocUploadSize') }}</span>
        <input
          v-model="uploadFileSizeThreshold"
          v-hkldinput
          v-fusioninputcheck="{type: 'integer', pattern: /^\d{1,10}$/, tip: $t('settings.threshold.hint', [1, 10])}"
          type="number"
          class="settings-engineers-threshold-input settings-file-size-threshold"
          :disabled="!editView"
          required
          @focus="showFileSizeHint = true"
          @blur="showFileSizeHint = false"
          @keyup="validate"
        >
        <span>{{ $t('settings.threshold.postMaxDocUploadSize') }}</span>
      </div>
      <p
        v-show="showFileSizeHint"
        class="file-size-hint-span"
      >
        {{ $i18n.t('settings.threshold.fileSizeHint') }}
      </p>
      <div class="threshold-value clearfix row">
        <div class="file-upload-type">
          {{ $t('settings.threshold.fileUpLoadType') }}
        </div>
        <textarea
          v-model="uploadFileTypesThreshold"
          v-hkldinput
          v-autosize
          v-fusioninputcheck="{type: 'string', required: true}"
          v-checkVisibility="{refresh: true}"
          type="text"
          class="autosize threshold-file-type"
          :disabled="!editView"
          required
          @keyup="validate"
        />
      </div>
    </form>
  </div>
</template>

<script>
import notification from '@/utils/notification'
import { getThreshold, updateThreshold } from '@/api/settings/request'
import { SETTING_CODE } from '@/api/settings/consts'
import { aclHelper } from '@/utils/aclHelper'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'
import currencyFormatter from 'currency-formatter'

export default {
  name: 'UploadedFiles',
  data () {
    return {
      disabled: true,
      editView: false,
      showFileSizeHint: false,
      amountThreshold: 0,
      uploadFileSizeThreshold: 0,
      uploadFileTypesThreshold: '',
      backThresholdData: {},
      aclHelper,
    }
  },
  computed: {
    formatedAmountThreshold () {
      return this.amountThreshold ? `${currencyFormatter.format(this.amountThreshold, 'USD')}` : '--'
    },
  },
  async mounted () {
    this.amountThreshold = await getThreshold(SETTING_CODE.tenderAmountThreshold) || this.amountThreshold
    this.uploadFileSizeThreshold = await getThreshold(SETTING_CODE.docUploadSize) || this.uploadFileSizeThreshold
    this.uploadFileTypesThreshold = await getThreshold(SETTING_CODE.docUploadTypes) || this.uploadFileTypesThreshold
    this.bakData()
  },
  destroyed () {
    if (this.thresholdAbide) {
      this.thresholdAbide.destroy()
    }
  },
  methods: {
    bakData () {
      this.backThresholdData.amountThreshold = this.amountThreshold
      this.backThresholdData.uploadFileSizeThreshold = this.uploadFileSizeThreshold
      this.backThresholdData.uploadFileTypesThreshold = this.uploadFileTypesThreshold
    },
    applyBakData () {
      this.amountThreshold = this.backThresholdData.amountThreshold
      this.uploadFileSizeThreshold = this.backThresholdData.uploadFileSizeThreshold
      this.uploadFileTypesThreshold = this.backThresholdData.uploadFileTypesThreshold
    },
    validate () {
      const elId = '#settings-engineers-threshold-form'
      fusionInputCheckUtil.validateAllFields({allowEmpty: 'false'}, elId)
      const isValid = fusionInputCheckUtil.isAllFieldsValid(elId)
      this.disabled = !isValid
      return isValid
    },
    toggleView () {
      this.bakData()
      this.editView = false
    },
    async save () {
      if (!this.validate()) {
        return
      }

      if (isNaN(this.amountThreshold)) {
        notification.fireNotification(false, this.$i18n.t('settings.threshold.NaN'))
        return
      }
      await updateThreshold({
        [SETTING_CODE.tenderAmountThreshold]: this.amountThreshold.toString(),
        [SETTING_CODE.docUploadSize]: this.uploadFileSizeThreshold.toString(),
        [SETTING_CODE.docUploadTypes]: this.uploadFileTypesThreshold,
      }, this.toggleView, this.discardChange)
      // @TODO <sam_liang> it should update the VUEX after the update request
    },
    discardChange () {
      this.applyBakData()
      this.editView = false
      fusionInputCheckUtil.resetAllFields()
      $('#settings-engineers-threshold-input').removeClass('is-invalid-input')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/settings/style';
#settings-engineers-threshold {
  padding: 0 24px 15px 24px;
}
.threshold-controls {
  width: 100%;
  text-align: right;
}

.threshold-value {
  width: 100%;
  margin-bottom: 10px;
}

.threshold-controls-header {
  font-size: 16px;
  font-weight: bold;
  margin: 0.85em 0;
}

.file-size-hint-span {
  margin-bottom: 10px;
}

.settings-engineers-threshold-input {
  display: inline-block;
  width: 200px;
}

#settings-engineers-threshold-input {
  display: inline-block;
  width: 200px;
}

.threshold-file-type {
  display: inline-block;
  width: calc(100% - 422px);
  margin: 0;
  vertical-align: text-top;
}

.file-upload-type {
  width: 422px;
  display: inline-block;
}
</style>
